import React, { Component } from "react";
import {
  Grid,
  Row,
  Col,
  FormGroup,
  ControlLabel,
  FormControl
} from "react-bootstrap";

import { Card } from "components/Card/Card.jsx";
import { FormInputs } from "components/FormInputs/FormInputs.jsx";
import Button from "components/CustomButton/CustomButton.jsx";
import ProgressButton from "components/ProgressButton/ProgressButton.jsx";
import FormErrors from "components/FormErrors/FormErrors.jsx";
import { WEB_URL } from "variables/Variables.jsx";

class UserProfile extends Component {
  constructor(props) {
      super(props);

      this.state = {
        runningAsyncOperation: false,
        formErrors: {email: '', password: ''},
        submitted : false,
        email: '',
        pass:''
      };

      this.emailInput = React.createRef(); 
  }


  handleUserInput (e) {
    const name = e.target.name;
    const value = e.target.value;
    const targetField = e.target;

    this.setState({[name]: value});
  }

  validateField(fieldName, value, targetField) {
    let fieldValidationErrors = this.state.formErrors;
    let emailValid = this.state.emailValid;
  
    switch(fieldName) {
      case 'email':
        emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
        if(!emailValid){
          fieldValidationErrors.email = emailValid ? '' : ' is invalid';
        }
        break;
      default:
        break;
    }
    this.setState({formErrors: fieldValidationErrors,
                    emailValid: emailValid
                  }, this.validateForm);
  }

  validateForm() {
    this.setState({formValid: this.state.emailValid});
  }

  handleSendPasswordRequestLink(e){
    let fieldValidationErrors = this.state.formErrors;
    e.preventDefault();
    this.setState({ runningAsyncOperation : true, submitted:true });

    fetch("https://"+WEB_URL+"/account/api/sendpasswordresetlink",{
      'method' : 'POST',
      'headers' : { 'Content-Type' : 'application/json'},
      //'body' : 'email='+this.state.email,
      'body' : JSON.stringify({'email':this.state.email}),
      'credentials': 'same-origin'
    }).then(res => res.json())
      .then(
        (resetResult) => {
            if(resetResult.result == 'SUCCESS'){
                this.props.triggerNotification('success','tc','Success! - A password request link has been sent to your email address.');
            }else if(resetResult.message){
                this.props.triggerNotification('error','tc',resetResult.message);
            }else{
                this.props.triggerNotification('error','tc','Failed Requesting a password reset code. Please check so you are using a valid email address.');
            }
            this.setState({ runningAsyncOperation : false });
        },
        (error) => {
          
          this.setState({ runningAsyncOperation : false });
        }
      )
  }

  render() {
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={8}>
              <Card
                title=""
                content={
                  <form>
                    <FormInputs
                      ncols={["col-md-12"]}
                      properties={[
                        {
                          label: "Email",
                          name: "email",
                          type: "text",
                          bsClass: "form-control",
                          placeholder: "Email",
                          defaultValue: ""
                        }
                      ]}
                      inputRef = {(input) => this.emailInput = input }
                      onChange={(event) => this.handleUserInput(event)} 
                    />
                    
                    <ProgressButton bsStyle="info" fill onClick={(e) => {this.handleSendPasswordRequestLink(e);}} type="submit" runningAsyncOperation={this.state.runningAsyncOperation}>
                      Send Password Reset Link
                    </ProgressButton>

                    <div className="clearfix" />

                    <div style={{paddingTop:20, visibility: this.state.submitted ? 'visible' : 'hidden'}}>
                      <FormErrors formErrors={this.state.formErrors} />
                    </div>
                  </form>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default UserProfile;
